import { renderToast } from 'components/CustomToast/CustomToast';
import { resetForReverification } from 'redux/familyBookingSlice';
import { AppDispatch } from 'redux/store';
import { loadOtpToken, saveOtpToken } from 'utils/storage';

export const SESSION_EXPIRED_MESSAGE =
  'Your session has expired. Please verify again.';

export const isFamilyBookingSessionExpired = (
  requestFailure: any,
  phoneNumber: string
) => requestFailure === 'Unauthorized' && !!loadOtpToken(phoneNumber);

const clearOtpToken = (phoneNumber: string) => saveOtpToken('', phoneNumber);

export const expireFamilyBookingSession = ({
  dispatch,
  phoneNumber,
}: {
  dispatch: AppDispatch;
  phoneNumber: string;
}) => {
  clearOtpToken(phoneNumber);

  dispatch(resetForReverification());

  renderToast({ message: SESSION_EXPIRED_MESSAGE });
};
